export const CompanyDefaultAvatarUrl = "/assets/img/avatar-default-company.png";
export const PersonDefaultAvatarUrl = "/assets/img/avatar-default-person.png";
export const UnknownAvatarUrl = "/assets/img/avatar-unknown.png";
export const EmptyAvatarUrl = "/assets/img/avatar-empty.png";
